import { Outlet } from "react-router-dom";

const AcademicMainPage = () => {
    return <Outlet />;
}

export default AcademicMainPage;